__turbopack_context__.v({
  "black": "index-module__2pkP9G__black",
  "clean": "index-module__2pkP9G__clean",
  "element": "index-module__2pkP9G__element",
  "grey": "index-module__2pkP9G__grey",
  "icon": "index-module__2pkP9G__icon",
  "is-disabled": "index-module__2pkP9G__is-disabled",
  "large": "index-module__2pkP9G__large",
  "lightBlueOnBlack": "index-module__2pkP9G__lightBlueOnBlack",
  "link": "index-module__2pkP9G__link",
  "orangeOnBlack": "index-module__2pkP9G__orangeOnBlack",
  "outline": "index-module__2pkP9G__outline",
  "regular": "index-module__2pkP9G__regular",
  "small": "index-module__2pkP9G__small",
  "solid": "index-module__2pkP9G__solid",
  "white": "index-module__2pkP9G__white",
  "wide": "index-module__2pkP9G__wide",
});
